<template>
    <div>
        <h1>Příjmy</h1>
        <LineChart url="/api/reports/incomes" label="Příjmy"></LineChart>
    </div>
</template>

<script>
    import LineChart from "./LineChart";

    export default {
        name: "ReportExpenses",
        components: {LineChart},
    }
</script>

<style scoped>

</style>